export default "__VITE_ASSET__C6RlJDv8__"